import React, { useEffect, useRef, useState } from 'react';
import iconUpload from '../../images/icon-upload.svg';
import axios from 'axios';
import * as securityHelper from "../../helper/SecurityHelper";

export default function SgstDtl({ detailData, setDetail, setSnackbarTxt, auth }: any) {
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const cntntsRef = useRef<any>();
  const user: any = securityHelper.getLoginUser();
  const btnRef = useRef<any>();
  const [saving, setSaving] = useState(false);
  const fileHandler = () => { fileRef.current.click(); };

  const fn_rcvSgstBtn = () => {
    btnRef.current.setAttribute("readonly", "readonly");
    setSaving(true);
  };

  useEffect(() => {
    if (saving) {
      fn_rcvSgst();
    }
  }, [saving]);

  const fn_rcvSgst = async () => {
    const cntnts = cntntsRef.current.value;
    const formData = new FormData();
    const fileList = fileRef.current.files;
    if (!cntnts) {
      setSnackbarTxt('내용을 입력해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      cntntsRef.current.focus();
      return;
    }
    if (fileList.length > 0) {
      formData.append('multipartFiles', fileList[0]);
    }
    const jsonObject = {
      sgstSeq: detailData.seq,
      answer: cntnts,
      prcsStatCd: '002',
      updtrSeq: user.seq
    }

    formData.append('jsonData', JSON.stringify(jsonObject));

    const rtrnData = await axios.post('admin/api/sgst/registSgstAswr', formData);
    if (rtrnData.data > 0) {
      setSnackbarTxt('접수 되었습니다.');
      setTimeout(() => setDetail(false), 1000);
    }
  }

  const fn_bakcToList = () => {
    setDetail(false);
  }

  const fn_delete = async (sgstSeq: number) => {
    if (!window.confirm('삭제 하시겠습니까?')) {
      return;
    }

    console.log('sgstSeq: ', sgstSeq);
    const rtrnData = await axios.post('admin/api/sgst/deleteSgstData', { sgstSeq: sgstSeq });
    if (rtrnData.data > 0) {
      setSnackbarTxt('삭제 되었습니다.');
      setDetail(false);
    }

  }

  console.log('detailData: ', detailData);

  const dataItemStyle = 'w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px]';
  const dataHeaderStyle = 'ml-7 text-14 leading-17 md:ml-[17px] md:text-35 md:leading-42px font-preBold';


  return (
    <div className={auth !== 'WOK' ? 'h-[calc(100%-154px)] md:h-[calc(100%-385px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'
      : 'h-[calc(100%-118px)] md:h-[calc(100%-295px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'}>
      <div className='w-[265px] sm:w-[318px] md:w-[750px] mb-25 md:mb-[62px]'>
        <div className='flex justify-between items-center mt-30 md:mt-[75px]'>
          <p className='ml-7 md:ml-[17px] font-preBold text-15 md:text-37 leading-18 md:leading-[45px]'>신고자 정보</p>
          {/* 응답완료 상태에서는 뜨지 않게 해놨습니다. 자기가 작성한 글일 경우만 추가하고 삭제 로직 추가하면 됩니다. */}
          {detailData.prcsStatCd === '001' && detailData.rgstrSeq == user.seq ?
            <button onClick={() => { fn_delete(detailData.seq) }} className='mr-7 md:mr-[17px] w-60 md:w-[150px] h-32 md:h-[80px] text-white text-14 md:text-35 leading-16 md:leading-[40px] rounded-[5px] md:rounded-[12px] bg-[#585959]'>삭제</button>
            : null}
        </div>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-15 md:mt-[37px] md:mb-[37px]' />
        <div className='flex items-center justify-between'>
          <p className={dataHeaderStyle}>행사명</p>
          <p className={dataItemStyle}>{detailData.evntNm}</p>
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>장소</p>
          <p className={dataItemStyle}>{detailData.exbtPlc}</p>
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>신고자</p>
          <p className={dataItemStyle}>{detailData.rgstrNm}</p>
        </div>
        <p className='mt-30 ml-7 font-preBold text-15 leading-18 md:mt-[75px] md:ml-[17px] md:text-37 md:leading-[45px]'>건의 내용</p>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-15 md:mt-[37px] md:mb-[37px]' />
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>접수처</p>
          <p className={dataItemStyle}>{detailData.rcptnGbNm}</p>
        </div>
        {detailData.rcptnGbCd === '003' ?
          <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
            <p className={dataHeaderStyle}>업체명</p>
            <p className={dataItemStyle}>{detailData.rcptntNm}</p>
          </div> : null
        }
        <div className='flex items-center justify-between mt-7 md:mt-[17px]'>
          <p className={dataHeaderStyle}>구분</p>
          <p className={dataItemStyle}>{detailData.sgstGbNm}</p>
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>내용</p>
          <p className={dataItemStyle}>{detailData.cntntsAll}</p>
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>날짜</p>
          <p className={dataItemStyle}>{detailData.rgstDt.substring(0,4)}년 {detailData.rgstDt.substring(5,7)}월 {detailData.rgstDt.substring(8,10)}일</p>
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>첨부사진</p>
          {detailData.atchFileId === null || detailData.atchFileId === "" ? <p className={dataItemStyle}>첨부된 사진이 없습니다.</p>
            : <img src={'admin/api/cmmn/fileDownload?atchFileId=' + detailData.atchFileId + '&fileSn=0'} alt='' className='w-[235px] h-129 md:w-[587px] md:h-[322px] border boder-[#D9D9D9] rounded-[5px] md:rounded-[12px]' />}
        </div>
        {detailData.prcsStatCd === '001' && detailData.rgstrSeq === user.seq ? null
        : <><p className='mt-30 ml-7 font-preBold text-15 leading-18 md:mt-[75px] md:ml-[17px] md:text-37 md:leading-[45px]'>응답하기</p>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-15 md:mt-[37px] md:mb-[37px]' />
        <div className='flex justify-between mt-16 md:mt-[40px]'>
            <p className={dataHeaderStyle}>응답</p>
            {detailData.prcsStatCd === '001' ?
              <textarea ref={cntntsRef} className='w-[235px] h-130 md:w-[587px] md:h-[325px] px-10 pt-10 md:px-[25px] md:pt-[25px] text-14 leading-16 md:text-35 md:leading-[40px] outline-none bg-[#F6F6F8] rounded-[5px] md:rounded-[12px] placeholder:text-14  md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-40  placeholder:font-preLight' placeholder='내용을 입력해주세요.' />
              : <p className={dataItemStyle}>{detailData.answer}</p>
            }

          </div>
            <div className='flex justify-between mt-16 md:mt-[40px]'>
              <p className='ml-7 text-14 leading-17 md:ml-[17px] md:text-35 md:leading-[42px] font-preBold'>사진첨부</p>
              <div className='w-[235px] md:w-[587px]'>
                {detailData.prcsStatCd === '002'
                  ? detailData.aswrAtchFileId === null || detailData.aswrAtchFileId === "" ? <p className='text-14 leading-17 md:text-35 md:leading-[42px]'>첨부된 사진이 없습니다.</p>
                    : <img src={'admin/api/cmmn/fileDownload?atchFileId=' + detailData.aswrAtchFileId + '&fileSn=0'} alt='' className='w-[235px] h-129 md:w-[587px] md:h-[322px] border boder-[#D9D9D9] rounded-[5px] md:rounded-[12px]' />
                  : !fileName
                    ? <button onClick={fileHandler} className='flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                      <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                      <p>사진 올리기</p>
                    </button>
                    : <button onClick={fileHandler} className='flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-point rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-point font-preLight'>{fileName}</button>}
              </div>
              <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
            </div></>
        }
      </div>
      <button ref={btnRef} onClick={detailData.rcptntSeq === user.companySeq && detailData.prcsStatCd === '001' ? fn_rcvSgstBtn : fn_bakcToList}
        className={`font-preLight text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] py-10 md:py-[25px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto mb-20 md:mb-[50px]`}>
        {detailData.rcptntSeq === user.companySeq && detailData.prcsStatCd === '001' ? '건의사항 접수' : '확인'}
      </button>
    </div>
  );
}

